<template>
  <div v-if="descTemplate" class="instype-result-wrap">
    <liability
      :temp="descTemplate"
      :data="descData"
      :product-name-list="template.productNameList"
      :show-type="1"
      @disShow="_fetchDisData"
      @setInsType="_bubbleEvent"
      @setDiseasesPath="_bubbleEvent"
      @setAccIns="_bubbleEvent"
      @openDisease="_bubbleEvent"
    />
  </div>
</template>

<script>
import Liability from 'components/liability/fmLiability'

export default {
  components: {
    Liability,
  },
  props: {
    template: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      descTemplate: '',
      descData: '',
      disData: [],
      disActive: 0,
      disVisible: false,
      disHeader: '病种详情',
      disLink: '',
    }
  },
  watch: {
    template(newTemplate) {
      this.pageInit(newTemplate)
    },
  },
  created() {
    this.pageInit()
  },
  methods: {
    // 初始化
    pageInit(temp = this.template) {
      if (temp) {
        this.descTemplate = {
          liabilities: temp.liabilities,
          // name: temp.card.name,
          // insuranceTypeId: temp.resultData.insuranceTypeId,
          // diff: temp.diff,
          // diffname: temp.diffname,
          // categorySort: temp.resultData.categorySort,
          accountMap: temp.accountMap,
          // insuredAge: temp.insuredAge,
        }
        this.descData = temp.calData
      }
    },
    _fetchDisData(path) {
      let { pidx, idx } = path

      let liabilities =
        this.descTemplate.liabilities[pidx].insuranceLiabilities[idx]
          .liabilities
      let diseaseAry = []
      liabilities.forEach((liab) => {
        let { title, link, detail } = liab.disease
        title &&
          diseaseAry.push({
            title,
            link,
            detail,
          })
      })

      this.disData = this._normalizeDisText(diseaseAry)
      this.disVisible = true
    },
    _bubbleEvent(eventName, value) {
      this.$emit(eventName, value)
    },
  },
}
</script>